import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStudentSubjectSelectionStatus } from "../../hooks/useStudentSubjectSelectionStatus";

/**
 * Redirect Form 3/4 pupils who still need to pick subjects to the choice page.
 */
export default function StudentSubjectSelectionGate({ children }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { loading, needsSelection, status } = useStudentSubjectSelectionStatus();

    const onChoicePage = pathname.startsWith("/Student/form3-subjects");
    const mustChoose = needsSelection && !status?.complete;

    useEffect(() => {
        if (loading || !mustChoose || onChoicePage) return;
        navigate("/Student/form3-subjects", { replace: true });
    }, [loading, mustChoose, onChoicePage, navigate]);

    if (!loading && mustChoose && !onChoicePage) {
        return null;
    }

    return children;
}
